var checkPrice = function (form) {
    var url = form.getAttribute('data-url') + '?amount=' + form.querySelector('input[name=quantity]').value + '&product=' + form.querySelector('input[name=product]').value;

    var data = getAjax(url, function (data) {
        var json = JSON.parse(data);
        if (json.note) {
            form.querySelector('.price-note').innerHTML = json.note;
            form.querySelector('.price-note').setAttribute('style', 'display: block;');
        } else {
            form.submit();
        }
    });
};

var calculatePrice = function (url, params, success) {
    var request = new XMLHttpRequest();
    request.open('GET', url + params, true);
    request.onload = function() {
        if (request.readyState > 3 && request.status == 200) {
            success(request.responseText);
            // var data = JSON.parse(request.responseText);
            // return request.xhr.responseText;
        }
    };
    request.onerror = function() { };
    request.send();
    return request;
};

var calculateDeliveryPrice = function (url) {
    var country = document.getElementById('l_delivery_country');
    var zip = document.getElementById('l_delivery_zip');
    var express = document.getElementById('l_delivery_express');
    var delivery = document.querySelector('input[name=delivery_mode]:checked');
    var price = document.getElementById('calc-delivery-price');
    var vat = document.getElementById('calc-delivery-vat');
    var params = params = '?country=' + country.value + '&zip=' + zip.value + '&delivery=' + delivery.value;

    if (express && country !== 'HU') {
        params += '&express=' + express.checked;
    }

    var request = new XMLHttpRequest();
    request.open('GET', url + params, true);
    request.onload = function() {
        if (request.status >= 200 && request.status < 400) {
            var data = JSON.parse(request.responseText);
            if (data.price == 0) {
                price.innerHTML = 'Ingyenes';
            } else {
                price.innerHTML = data.price;
                vat.innerHTML = data.vat;
            }
        }
    };
    request.onerror = function() { };
    request.send();
};

function submitRecaptchaForm (){
    var form = document.getElementsByClassName('custom-form');
    form[0].submit();
}
